export default "__VITE_ASSET__DDIHo4Ep__"